export default {"src":"/_next/static/media/down-arrow.d2deb2c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};